import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreateStudent } from "../api/queries";
import { StudentForm } from "../ui/StudentForm";

export function StudentCreatePage() {
  const nav = useNavigate({ from: "/app/students/create" });
  const createStudent = useCreateStudent();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ນັກຮຽນ", to: "/app/students" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງນັກຮຽນ
            </h2>
            <p className="text-muted-foreground">
              ສ້າງນັກຮຽນໃໝ່ໃນລະບົບ. Member ID ຈະຖືກສ້າງອັດຕະໂນມັດ.
            </p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/students" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <StudentForm
            onSubmit={async (vals) => {
              try {
                const result = await createStudent.mutateAsync(vals);
                nav({
                  to: "/app/students/$id",
                  params: { id: result.id },
                  search: { printMembership: "1" },
                });
              } catch {
                // Error handling is done by the mutation
              }
            }}
            submitting={createStudent.isPending}
          />
        </div>
      </Main>
    </>
  );
}
